import state from './ocaTypeState'
import actions from './ocaTypeActions'
import mutations from './ocaTypeMutations'
import getters from './ocaTypeGetters'

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}